export enum RoutesType {
  ContractsList = "/insurance-contracts",
  ContractsCase = "/insurance-contracts/case/",
  ProgramsList = "/insurance-programs",
  ProgramsCase = "/insurance-programs/case/",
  InsuredPersons = "/insured-persons",
  InsuredPersonCase = "/insured-persons/case/",
  TasksList = "/tasks",
  TaskCase = "/tasks/case/",
  CreateTask = "/createTask/",
  Auth = "/auth",
  Dev = "/dev",
  Policy = "/processing-policy",
  Contacts = "/contacts",
  Statistics = "/statistics",
  Feedback = "/feedback",
  EditTask = "/edit-task/",
  Projects = "/projects/",
  BonusProgram = "/bonus-program",
  InsuranceOfRelatives = "/insurance-of-relatives",
  AppPage = "/app",
  AppSpot = "/app/spot",
  Fallback = "*",
  Redirect = "/",
}
